const pwaBaseUrl = process.env.REACT_APP_PWA_URL || process.env.REACT_APP_STAGING_BASE_URL || '';

function joinPwaPath(path: string): string {
	return `${pwaBaseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export const pwaRoutes = {
	login: () => joinPwaPath('/users/sign_in'),
	signup: () => joinPwaPath('/sign_up'),
	passwordReset: () => joinPwaPath('/users/password/new'),
};
